module.exports = __webpack_public_path__ + "static/tags_2-557c021bbd91b75047e0bb3c0371d1df.webm";